import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/img/user.png'


const _hoisted_1 = { class: "evse evse-details details" }
const _hoisted_2 = { class: "detail-top" }
const _hoisted_3 = { class: "section-header" }
const _hoisted_4 = { class: "section-header__block" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    height: "50"
  })
], -1)
const _hoisted_6 = { class: "info-tags" }
const _hoisted_7 = { class: "app-wrapper" }

import { computed, onMounted } from 'vue'
import { ElMessageBox as MB, ElMessage } from 'element-plus'
import { Edit } from '@element-plus/icons-vue'
import { useRoute, useRouter } from 'vue-router'
import DetailHeader from '@/components/DetailHeader.vue'
import { getUserInfo } from '@/api/operation'
import { checkMenuShow } from '@/store/tool'
import UserEditDialog from './components/UserEditDialog.vue'
import useProtocolEnums from '@/hooks/useProtocolEnums'
import Orders from '@/views/Orders/Orders.vue'
import UserWallet from './components/UserWallet.vue'

import useI18nTl from '@/hooks/useI18nTl'

import { defineComponent, ref, Ref } from 'vue'
const __default__ = defineComponent({
  name: 'UserDetail',
})

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const { t } = useI18nTl('Evses')

const { getCountry, getCurrency, getCurrencySymbol } = useProtocolEnums()

const route = useRoute()
const userid = computed(function () {
  return route.params.id
})
const user = ref<Record<string, any>>({
  id: userid,
})
const showDialog = ref(false)
const operatorDetailLock = ref(false)
const dataLoaded = ref(false) // 标识数据是否加载完成
const currTab = ref('wallet')

const editOperator = () => {
  showDialog.value = true
}

const loadData = async function () {
  operatorDetailLock.value = true
  try {
    const res = await getUserInfo({ userID: userid.value })
    user.value = res.user
    dataLoaded.value = true // 数据加载完成后设置为 true
  } catch (error) {
    console.error('Error fetching table data:', error)
  } finally {
    operatorDetailLock.value = false
  }

  // getUserInfo({
  //   userID: userid.value,
  // }).then((res: any) => {
  //   user.value = res.user
  // }).catch((error: any) => {
  //   console.error('Error fetching table data:', error)
  // })
}
const updateEnable = async () => {
  try {
    // await banUser(user.id, user.enable)
    // if (!user.enable) {
    //   ElMessage.success(t('Base.disabledSuccess'))
    // } else {
    ElMessage.success(t('Base.enableSuccess'))
    // }
    return Promise.resolve()
  } catch (error) {
    console.error(error)
    return Promise.reject()
  }
}

const initData = async () => {
  await loadData()
}

onMounted(async () => {
  await loadData()
})
// await loadData()
// initData()
// onMounted(initData);

return (_ctx: any,_cache: any) => {
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(DetailHeader, {
        item: { name: user.value.account }
      }, null, 8, ["item"]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_6, [
              (user.value.phone != '')
                ? (_openBlock(), _createBlock(_component_el_tag, {
                    key: 0,
                    type: "primary",
                    effect: "plain",
                    size: "small",
                    hit: false,
                    round: ""
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(user.value.phone), 1)
                    ]),
                    _: 1
                  }))
                : (user.value.email != '')
                  ? (_openBlock(), _createBlock(_component_el_tag, {
                      key: 1,
                      type: "primary",
                      effect: "plain",
                      size: "small",
                      hit: false,
                      round: ""
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(user.value.email), 1)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
            ])
          ])
        ]),
        _createElementVNode("div", null, [
          _createVNode(_component_el_tooltip, {
            content: user.value.enable ? _ctx.$t('Base.enable') : _ctx.$t('Base.disable'),
            placement: "top"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_switch, {
                class: "enable-btn",
                disabled: !_ctx.$hasPermission('post'),
                modelValue: user.value.enable,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((user.value.enable) = $event)),
                onChange: updateEnable
              }, null, 8, ["disabled", "modelValue"])
            ]),
            _: 1
          }, 8, ["content"]),
          _createVNode(_component_el_tooltip, {
            content: _ctx.$t('Base.edit'),
            placement: "top"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_button, {
                class: "icon-button",
                disabled: !_ctx.$hasPermission('post'),
                type: "primary",
                icon: _unref(Edit),
                plain: "",
                size: "small",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (editOperator()))
              }, null, 8, ["disabled", "icon"])
            ]),
            _: 1
          }, 8, ["content"])
        ])
      ])
    ]),
    _withDirectives((_openBlock(), _createBlock(_component_el_tabs, {
      class: "detail-tabs",
      modelValue: currTab.value,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((currTab).value = $event))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_7, [
          (_unref(checkMenuShow)('walletTransaction') && dataLoaded.value)
            ? (_openBlock(), _createBlock(_component_el_tab_pane, {
                key: 0,
                label: _ctx.$t('Operation.walletTransaction'),
                name: "wallet",
                lazy: true
              }, {
                default: _withCtx(() => [
                  _createVNode(UserWallet, {
                    operatorID: user.value.operatorID,
                    userID: user.value.id
                  }, null, 8, ["operatorID", "userID"])
                ]),
                _: 1
              }, 8, ["label"]))
            : _createCommentVNode("", true),
          (dataLoaded.value)
            ? (_openBlock(), _createBlock(_component_el_tab_pane, {
                key: 1,
                label: _ctx.$t('components.sessions'),
                name: "sessions",
                lazy: true
              }, {
                default: _withCtx(() => [
                  _createVNode(Orders, {
                    userID: user.value.id
                  }, null, 8, ["userID"])
                ]),
                _: 1
              }, 8, ["label"]))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])), [
      [
        _directive_loading,
        operatorDetailLock.value,
        void 0,
        { lock: true }
      ]
    ]),
    _createVNode(UserEditDialog, {
      modelValue: showDialog.value,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((showDialog).value = $event)),
      user: user.value,
      onSubmitted: loadData
    }, null, 8, ["modelValue", "user"])
  ]))
}
}

})